var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footermain"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"footer-copyright"},[_c('p',[_vm._v("ⓒ Copyrights 2026 | SYNAPSE")])])])])
}]

export { render, staticRenderFns }